import { FC } from "react";
import styles from "./table-row-actions.module.scss";
import { ReactComponent as DeleteIcon } from "./assets/delete.svg";
import { ReactComponent as EditIcon } from "./assets/edit.svg";
import { IconButton } from "../iconButton/IconButton";
import { Tooltip } from "../tooltip/Tooltip";

type Props = {
  id: number;
  handler: (type: "edit" | "delete", id: number) => boolean;
};

export const TableRowActions: FC<Props> = ({ id, handler }) => {
  return (
    <div className={styles.box}>
      <Tooltip label="Редактировать запись">
        <IconButton onClick={() => handler("edit", id)}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip label="Удалить запись">
        <IconButton onClick={() => handler("delete", id)}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};
